import React, { useState, useEffect } from "react";
import { Form, Input, Button, Card, Typography, Alert } from "antd";
import { SecurityScanOutlined, MailOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const TwoStepVerification = () => {
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setTimeout(() => setTimer(timer - 1), 1000);
      return () => clearTimeout(countdown);
    } else {
      setCanResend(true);
    }
  }, [timer]);

  const handleResendCode = () => {
    setTimer(30);
    setCanResend(false);
    // Resend logic here
  };

  const onFinish = (values) => {
    console.log("Verification code:", values);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-md w-full mx-4">
        <Card className="shadow-2xl border-0 rounded-2xl">
          <div className="text-center mb-6">
            <SecurityScanOutlined className="text-4xl text-blue-600 mb-4" />
            <Title level={2}>Two-Step Verification</Title>
            <Text type="secondary">
              We've sent a verification code to your email
            </Text>
          </div>

          <Alert
            message="Check your email"
            description="Please enter the 6-digit code sent to your email address."
            type="info"
            showIcon
            className="mb-6"
          />

          <Form
            name="verification"
            onFinish={onFinish}
            layout="vertical"
            size="large">
            <Form.Item
              name="code"
              label="Verification Code"
              rules={[
                {
                  required: true,
                  message: "Please input the verification code!",
                },
                { len: 6, message: "Code must be 6 digits!" },
              ]}>
              <Input.OTP length={6} className="justify-center" size="large" />
            </Form.Item>

            <Form.Item className="mb-4">
              <Button
                type="primary"
                htmlType="submit"
                className="w-full h-12 rounded-lg text-lg font-semibold bg-blue-600 hover:bg-blue-700 border-0">
                Verify & Continue
              </Button>
            </Form.Item>
          </Form>

          <div className="text-center">
            <Text type="secondary">
              Didn't receive the code?{" "}
              {canResend ? (
                <Button type="link" onClick={handleResendCode} className="p-0">
                  Resend Code
                </Button>
              ) : (
                <Text type="secondary">Resend in {timer}s</Text>
              )}
            </Text>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default TwoStepVerification;
